<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" /> 
			<span>课程简介</span><i class="el-icon-arrow-right"></i>&nbsp;<span>课程列表</span>
		</div>
		<el-container class="content">
			<div class=" zy_content clearfix">
				<div class="zy_index_title">
					<img src="@/images/title_back1.png" class="zy_index_titleback" />
					<img src="@/images/zy-title5.png" class="zy_index_titlename" />
					<div class="zy_index_titleright clearfix">
						<div class="zy_index_titlerightitem" :class="typeId == majorIdForAll ?'active':''" @click="typeChange(majorIdForAll)">
							<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
							<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
							<div class="zy_index_titlerightinfo">全部</div>
						</div>
						<div class="zy_index_titlerightitem" :class="item.id == typeId ?'active':''" v-for="(item, index) in typeList" :key="'type' + index" @click="typeChange(item.id)">
							<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
							<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
							<div class="zy_index_titlerightinfo text-ellipsis">{{item.name}}</div>
						</div>
					</div>
				</div>
				<div class="zy_maincont clearfix">
					<div v-if="!courses || courses.length<=0" class="simulation_empty_msg_content">暂无课程</div>
					<div class="clearfix" >
						<div class="zy_courseitem" v-for="(item,index) in courses">
							<img src="@/images/course_back.png" class="zy_course_back" />
							<div class="zy_course_cont">
								<div class="zy_course_img">
									<img :src="baseurl + item.banner" />
								</div>
								<div class="zy_course_info">
									<div class="zy_course_title">{{item.name}}</div>
									<div class="zy_course_P1">主讲人：{{item.username}}</div>
									<div class="zy_course_P2 text-ellipsistwo">简介：{{item.info}}</div>
									<div class="zy_course_P3 clearfix">
										<img src="@/images/zy_course_in.png" class="l" @click="toCourseindex(item)" />
										<span class="r">
										<i class="el-icon-s-custom"></i>{{addCount(item) || 0}}人已学习
									</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="all_live_page" v-if="courses && courses.length>0">
						<el-pagination background @current-change="pageChange" :page-size="pageSize" :current-page="page" layout="prev, pager, next" :total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth'
	import { listMajorByPid } from '@/api/major'
	import { appCourseList } from '@/api/course'
	export default {
		name: 'news',
		data() {
			return {
				page: 1,
				pageSize: 8,
				total: 0,
				typeId: this.majorIdForAll,
				name: '',
				typeList: [],
				courses: [],
			}
		},
		created() {
			this.getCourseTypes();
			this.getCourse();
		},
		mounted() {

		},
		methods: {
			addCount(item){
				var count =0
				if(item.count && !Number.isNaN(count)){
					count = item.count*1
				}
				var addNumber = 800;
				if(item.name == '针灸学' || item.name == '推拿学'){
					addNumber = 2000;
				}else if(item.name == '传统养生功法' || item.name == '保健按摩'){
					addNumber = 900;
				}else if(item.name == '推拿手法' || item.name == '足反射疗法'){
					addNumber = 1000;
				}
				return count+addNumber
			},
			pageChange(page) {
				this.page = page;
				this.getCourse();
			},
			typeChange(id) {
				this.typeId = id;
				this.getCourse();
			},
			//课程导航切换
			getCourseTypes() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(({
					data
				}) => {
					this.typeList = data;
				})
			},
			getCourse() {
				var data = {
					major_id: this.majorIdForAll,
					type_id: this.typeId == this.majorIdForAll ? null : this.typeId,
					name: this.name ? this.name : null,
					page: this.page,
					pageSize: this.pageSize,
				}
				appCourseList(data).then(res => {
					if(res.code == 0) {
						this.courses = res.data.listData;
						this.total = res.data.totalRow;
					}
				})
			},
			toCourseindex(item) {
				var token = getStorageToken();
				if(token) {
					this.$router.push({
						name: 'courseindex',
						query: {
							id: item.id
						}
					})
				} else if(item.publicWelfare == '1') {
					this.$router.push({
						name: 'courseindexpublic',
						query: {
							id: item.id
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
		},
		beforeRouteLeave(to, from, next) {
			next();
		},
	}
</script>

<style>

</style>